import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

// Layout components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import HomePage from './pages/HomePage';
import InstitutePage from './pages/InstitutePage';
import WeddingServicesPage from './pages/WeddingServicesPage';
import CorporateEventsPage from './pages/CorporateEventsPage';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="font-sans min-h-screen flex flex-col bg-gradient-to-b from-white to-orange-50">
        <Navbar />
        <AnimatePresence mode="wait">
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/institute" element={<InstitutePage />} />
              <Route path="/wedding-services" element={<WeddingServicesPage />} />
              <Route path="/corporate-events" element={<CorporateEventsPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
        </AnimatePresence>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
